export const tableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Producto, Proceso o Servicio',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría de producto, Proceso o Servicio',
                    type: 'custom-html',
                    key: 'level_5_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Documento normativo',
                    type: 'custom-html',
                    key: 'level_6_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Modificatorias a los Documentos Normativos',
                    type: 'custom-html',
                    key: 'level7',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Tipo de esquema de certificación',
                    type: 'custom-html',
                    key: 'level_8_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Especificación técnica',
                    type: 'custom-html',
                    key: 'level9',
                    modifier: (item) => {
                        return item;
                    }
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}